module.exports = __webpack_public_path__ + "static/media/dpd-ireland.cd129a2c.jpg";